import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import GoogleLogin from './components/Auth/GoogleLogin';
import Sidebar from './components/Layout/Sidebar';
import { AssistantPane, AssistantProvider } from './components/AssistantDock';
import Assets from './pages/Assets';
import CreativeLibrary from './pages/CreativeLibrary';
import Album from './pages/Album';
import AlbumOrder from './pages/AlbumOrder';
import WhatsAppTemplates from './pages/WhatsAppTemplates';
import Cadences from './pages/Cadences';
import KnowledgeBase from './pages/KnowledgeBase';

/** Signed-in pages: the sidebar beside a scrolling warm-white main. */
const Shell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated
    ? (
      <div className="flex h-screen">
        <Sidebar />
        <AssistantPane>{children}</AssistantPane>
      </div>
    )
    : <Navigate to="/login" />;
};

const PAGES: [string, React.ReactNode][] = [
  ['/assets', <Assets />],
  ['/creative-library', <CreativeLibrary />],
  ['/album', <Album />],
  ['/album/order', <AlbumOrder />],
  ['/whatsapp-templates', <WhatsAppTemplates />],
  ['/cadences', <Cadences />],
  ['/knowledge-base', <KnowledgeBase />],
];

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Router>
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/assets" /> : <GoogleLogin />} />
        {PAGES.map(([path, page]) => <Route key={path} path={path} element={<Shell>{page}</Shell>} />)}
        <Route path="/" element={<Navigate to="/assets" />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AssistantProvider>
        <AppContent />
      </AssistantProvider>
    </AuthProvider>
  );
}

export default App;
